import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import mastercard_logo from '../images/mastercard.png'
import wechatpayAliPay_logo from '../images/wechatAlipay.png'
import visacard_logo from '../images/visa.png'
import paypal_logo from '../images/paypal.png'
import { Typography } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PaypalExpressBtn from 'react-paypal-express-checkout';
import {RadioGroup, Radio} from 'react-radio-group';
import * as actions from '../../store/actions/index';
import FeeCalculator from '../../components/FeeCalculator';
import ArbitrationFeeTable from '../../components/ArbitrationFeeTable';
import PaymentAsia from './PaymentAsia';
import { connect } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
var commaNumber = require('comma-number');

const CLIENT = {
    sandbox: process.env.PAYPAL_CLIENT_ID_SANDBOX,
    production: process.env.PAYPAL_CLIENT_ID_PRODUCTION,
  };

const ENV = process.env.NODE_ENV === 'production'
? 'production'
: 'sandbox';

const styles = theme => ({
    paper:{
        width: '50%',
        margin: '0 Auto',
    },
    root: {
        justifyContent: 'center',
        alignItems:'center',
        align:'center'
    },
    button:{
        width: '50%',
        display: 'flex',
        margin: '0 Auto',
        //justifyContent: 'center',
    },
    buttonPay: {
        margin: theme.spacing.unit,
    },
    listItemText:{
        display: 'flex',
        justifyContent: 'center',
    },
    header:{
        align:"center"
    },
    menuItem: {
      '&:focus': {
        backgroundColor: theme.palette.primary.main,
        '& $primary': {
          color: theme.palette.common.white,
        },
      },
    },
    primary: {},
});

function createData(amountInDispute, fee) {
return { amountInDispute, fee};
}
  
const rows = [
      createData('At or below 1,000', '100.00'),
      createData('At or between 1,001 and 2,000', '200.00'),
      createData('At or between 2,001 and 5,000', '500.00'),
      createData('At or between 5,001 and 10,000', '1,000.00'),
      createData('At or between 10,001 and 15,000', '1,500.00'),
      createData('At or between 15,001 and 20,000', '2,000.00'),
      createData('At or between 20,001 and 50,000', '2,500.00'),
      createData('At or between 50,001 and 100,000', '5,000.00'),
      createData('At or between 100,001 and 150,000', '7,500.00'),
      createData('At or between 150,001 and 250,000', '12,500.00'),
      createData('At or between 250,001 and 500,000', '25,000.00'),
      createData('At or between 500,000 and 1,500,000', '37,500.00'),
      createData('At or between 1,5000,001 and 3,000,000', '75,000.00'),
      createData('At or between 3,000,001 and 10,000,000', '125,000.00'),
      createData('Over 10,000,000', '175,000.00'),
    ];

class PaymentTeleconferencing extends Component{
    state = {
        paymentMethod: null,
        userType: null,
        uniqueId: localStorage.getItem('token'),
        value: 0,
        total: 100
    }

    handleselectedPayment = (index) => {
        console.log('handleselectedPayment: '+index)
        this.setState({paymentMethod: index})
        console.log('handleselectedPayment state: '+this.state.paymentMethod)
    }

    handleCompleteStep(){
        this.props.handleComplete();
    }

    componentWillMount(){
        this.setState({
            value: parseInt("100")
        })
        // console.log('the case is kind_of_claim: '+this.props.caseData.kind_of_claim)
        // if (this.props.caseData.kind_of_claim == 'estate_agent_dispute_seperate_agent'){
        //     if (this.props.caseData.a1 == 'sole'){

        //         if (this.props.caseData.a2 === 'vendor'){
        //             this.setState({
        //                 value: parseInt(this.props.caseData.a15f)
        //             })
        //         }
        //         else if (this.props.caseData.a2 === 'purchaser'){
        //             this.setState({
        //                 value: parseInt(this.props.caseData.a16f)
        //             })
        //         }

        //     }
        //     else if (this.props.caseData.a1 == 'seperate'){
        //         this.setState({
        //             value: parseInt(this.props.caseData.a16f)
        //         })
        //     }

        // }
        // else if (this.props.caseData.kind_of_claim == 'money_lent'){
        //     this.setState({
        //         value: parseInt(this.props.total_outstanding_loan)
        //     })
        // }
        // else if (this.props.caseData.kind_of_claim == 'other_dispute'){
        //     console.log('the case is other duspute with balance: '+this.props.caseData.a19)
        //     this.setState({
        //         value: parseInt(this.props.caseData.a19)
        //     })
        // }

        console.log('121 value: '+this.state.value);
        
        // setTimeout(()=>{
        //     if (this.state.value <= 1000){
        //         this.setState({
        //             total: 100
        //         })
        //     }
        //     else if (this.state.value >= 1001 &&
        //         this.state.value <= 2000){
        //         this.setState({
        //             total: 200
        //         })
        //     }
        //     else if (this.state.value >= 2001 &&
        //         this.state.value <= 5000){
        //         this.setState({
        //             total: 500
        //         })
        //     }
        //     else if (this.state.value >= 5001 &&
        //         this.state.value <= 10000){
        //         this.setState({
        //             total: 1000
        //         })
        //     }
        //     else if (this.state.value >= 10001 &&
        //         this.state.value <= 15000){
        //         this.setState({
        //             total: 1500
        //         })
        //     }
        //     else if (this.state.value >= 15001 &&
        //         this.state.value <= 20000){
        //         this.setState({
        //             total: 2000
        //         })
        //     }
        //     else if (this.state.value >= 20001 &&
        //         this.state.value <= 50000){
        //         this.setState({
        //             total: 2500
        //         })
        //     }
        //     else if (this.state.value >= 50001 &&
        //         this.state.value <= 100000){
        //         this.setState({
        //             total: 5000
        //         })
        //     }
        //     else if (this.state.value >= 100001 &&
        //         this.state.value <= 150000){
        //         this.setState({
        //             total: 7500
        //         })
        //     }
        //     else if (this.state.value >= 150001 &&
        //         this.state.value <= 250000){
        //         this.setState({
        //             total: 12500
        //         })
        //     }
        //     else if (this.state.value >= 250001 &&
        //         this.state.value <= 500000){
        //         this.setState({
        //             total: 25000
        //         })
        //     }
        //     else if (this.state.value >= 500001 &&
        //         this.state.value <= 1500000){
        //         this.setState({
        //             total: 37500
        //         })
        //     }
        //     else if (this.state.value >= 1500001 &&
        //         this.state.value <= 3000000){
        //         this.setState({
        //             total: 75000
        //         })
        //     }
        //     else if (this.state.value >= 3000001 &&
        //         this.state.value <= 10000000){
        //         this.setState({
        //             total: 125000
        //         })
        //     }
        //     else if (this.state.value >= 10000000){
        //         this.setState({
        //             total: 175000
        //         })
        //     }
        // },3000)
        
        console.log('182 total: '+this.state.total);
        console.log('payment this.state.uniqueId: '+this.state.uniqueId);
        console.log('payment this.props.claimantUniqueId: '+this.props.claimantUniqueId);
        console.log('payment this.props.respondentUniqueId: '+this.props.respondentUniqueId);
        
        if (this.state.uniqueId == this.props.claimantUniqueId){
            this.setState({
                userType : 'claimant'
            });
        }
        else if (this.state.uniqueId == this.props.respondentUniqueId){
            this.setState({
                userType : 'respondent'
            });
        }
    }

    componentDidMount(){
        console.log('Payment handleComplete: '+JSON.stringify(this.props.handleComplete));
        console.log('caseData in payment: '+JSON.stringify(this.props.caseData));

        this.setState({
            value: parseInt("100")
        })
    }

    render(){
        const { classes } = this.props;
        
        const onSuccess = (payment) => {
           console.log("The payment was succeeded!", payment);

           var payment_details = {};

           var payment_details = {
               city: payment.address.city,
               country_code: payment.address.country_code,
               line1: payment.address.line1,
               line2: payment.address.line2,
               postal_code: payment.address.postal_code,
               recipient_name: payment.address.recipient_name,
               state: payment.address.state,
               cancelled: payment.cancelled,
               email: payment.email,
               paid: payment.paid,
               payerID: payment.payerID,
               paymentID: payment.paymentID,
               paymentToken: payment.paymentToken,
               returnUrl: payment.returnUrl,
               status: 'paid'
           };

            let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/saveTeleconferencePaymentDetails`;
            let payload = {
                payment_details: payment_details,
                userType: this.state.userType,
                caseId: this.props.caseId
            }
            axios.post(url, payload)
            .then((response) => {
                if(response.data === 'error' || response.data === 'failed'){
                    throw (`login ${response.data}`);
                }
                //this.handleCompleteStep();
                // this.props.handleComplete();
                this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'));
                // steps_completed 
                // let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/steps_completed`;
                // let payload = {
                //     step_completed: 5,
                //     userType: this.state.userType,
                //     caseId: this.props.caseId
                // }

                // axios.post(url, payload)
                // .then((response) => {
                //     if(response.data === 'error' || response.data === 'failed'){
                //         throw (`login ${response.data}`);
                //     }
                    
                //     // TODO 
                //     // send user to next step
                //     //this.props.modifyStepsCompleted({"verification":true,"choose_arbitrator":true,"read_pdf":true,"sign":true,"payment":true,"upload_docs":false,"newAccount":false});

                // })
                // .catch((error) => {
                //     console.log(error);
                // });

            })
            .catch((error) => {
                console.log(error);
            });

        }
 
        const onCancel = (data) => {
            console.log('The payment was cancelled!', data);
            
        }
 
        const onError = (err) => {
            console.log("Error!", err);
        }

        let env = 'production'; // you can set here to 'production' for production
        let currency = 'HKD'; // or you can set this value from your props or state
        //var total = 0; // same as above, this is the total amount (based on currency) to be paid by using Paypal express checkout

        
        const client = {
            // sandbox:    'ASQkIR_m-Fin-gujULVy5bcl22zbFznPtbUKmG4TpRSKB84xigbMwXljrri3rBmrhq3MtRwBb7ImpsiR'
            production:  'AarPpZyA16rySnFZqMks5HixP532ClcQjqnC-KBGlzQShxzQAWoNy_paEEXZ5vUKHSQf_paQc1UaNI4Q',
        }
        
        return(
        <div className={classes.root} style = {{marginBottom:'50px'}}>
            <Typography style={{fontSize: '15px', marginBottom: '20px', marginTop:'50px'}}>
                {this.context.t('Please select payment method:')}
            </Typography>
            
            <RadioGroup name="paymentMethodSelector" selectedValue={this.state.selectedValue} onChange={this.handleselectedPayment} style={{fontSize: '12px', marginTop:'30px'}}>
                <p><Radio value="mastercard" name="handleselectedPayment" style={{marginRight:'10px',marginLeft:'30px',}} /> <img src={wechatpayAliPay_logo} style={{marginRight:'10px', width:'120px', height:'115px'}}/> {this.context.t('WeChat Pay / AliPay')} </p>
                <p><Radio value="paypal" name="handleselectedPayment" style={{marginRight:'10px',marginLeft:'30px',}} /> <img src={paypal_logo} style={{marginRight:'10px', width:'230px', height:'120px'}} />{this.context.t('PayPal / CreditCard')}</p>
            </RadioGroup>
            
            <Table className={classes.root} fixedHeader={false}>
                <TableBody>
                    <TableRow>
                    <TableCell className={classes.leftCell} align="left" style={{fontSize:'15px', marginRight:'10px'}}>{this.context.t('Order details')}:</TableCell>
                    </TableRow>
                    {/* <TableRow>
                        <TableCell className={classes.leftCell} align="left" style={{fontSize:'15px', marginRight:'10px'}}>{this.context.t('Dispute amount')}: HK${commaNumber(parseInt(this.state.value))}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.leftCell} align="left" style={{fontSize:'15px', marginRight:'10px'}}>{this.context.t('Arbitration Fee')}: HK${commaNumber(parseInt(this.state.total))}</TableCell>
                    </TableRow> */}
                    <TableRow>
                        <TableCell className={classes.leftCell} align="left" style={{fontSize:'20px', marginRight:'10px'}}>{this.context.t('Final Total for Hearing')}: HK${commaNumber(parseInt(this.state.total))}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            
            <Typography className={classes.root} style={{marginTop:'10px', marginBottom:'10px'}}>
                {this.state.paymentMethod == 'mastercard' && <PaymentAsia env={env} client={client} currency={currency} total={this.state.total} onError={onError} onSuccess={onSuccess} onCancel={onCancel} />}
            </Typography>
            <Typography className={classes.root} style={{marginTop:'10px', marginBottom:'10px'}}>
                {this.state.paymentMethod == 'visa' && <PaymentAsia env={env} client={client} currency={currency} total={this.state.total} onError={onError} onSuccess={onSuccess} onCancel={onCancel} />}
            </Typography>
            <Typography className={classes.root} style={{marginTop:'10px', marginBottom:'10px'}}>
                {this.state.paymentMethod == 'paypal' && <PaypalExpressBtn env={env} client={client} currency={currency} total={this.state.total} onError={onError} onSuccess={onSuccess} onCancel={onCancel} />}
            </Typography>

            {/* <ArbitrationFeeTable style={{marginBottom:'50px'}} /> */}

            <Typography className={classes.root} style={{marginTop:'10px', marginBottom:'10px'}}>
                {this.context.t('The arbitration fees will be paid to the arbitration service provider approved by Hong Kong Arbitration Society.')}
            </Typography>
            
        </div>
        );
    }
}

// export default withStyles(styles)(Payment);

const mapStateToProps = (state, ownProps) => {
    return {
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        total_outstanding_loan: state.caseInfo.total_outstanding_loan,
        caseData: state.caseInfo.caseData
        //handleComplete: ownProps.handleComplete
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
           getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId))
    }
}

PaymentTeleconferencing.contextTypes = {
    t: PropTypes.func
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(PaymentTeleconferencing));